module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 15h16v1H2v-1zm11-3h5v1h-5v-1zm-2 1H2V6h9v7zm-1-6H3v5h7V7zm3 2h5v1h-5V9zm0-3h5v1h-5V6zM2 3h16v1H2V3z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ../ckeditor5-core/theme/icons/object-left.svg
// module id = 543
// module chunks = 0